import modalProps from '../modalProps';

export default () => () => modalProps().onClose()
